import { Badge, Tooltip, cn } from '@skupreme/shared/ui';
import { type StageOrder, getStage, isStageShown } from '../../lib/stage';

export type StageBadgeProps = {
  order: StageOrder | null | undefined;
  /** The list row's chip size; the detail card uses the default badge. */
  compact?: boolean;
  className?: string;
};

/** The V2 order's stage; nothing for a legacy order or a stage never shown (Routed). */
export function StageBadge({ order, compact, className }: StageBadgeProps) {
  const stage = getStage(order);

  if (!stage || !isStageShown(stage.stage)) {
    return null;
  }

  return (
    <Tooltip placement="bottom start" content={stage.hint}>
      <span className={cn('sk:inline-flex sk:cursor-default', className)}>
        <Badge
          tone={stage.tone}
          className={cn(compact && 'sk:text-xs sk:font-normal')}
        >
          {stage.label}
        </Badge>
      </span>
    </Tooltip>
  );
}
